import clsx from 'clsx';

import { ReachSummary } from '@/components/pages/edit-campaign/use-reach-summary';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

import { useMetricContent } from './use-metric-content';

interface MetricProps {
  metricKey: keyof ReachSummary;
  value?: number;
  className?: string;
  isFetching: boolean;
}

export function Metric({
  metricKey,
  value,
  className,
  isFetching,
}: MetricProps) {
  const { label, icon, format } = useMetricContent({ metricKey });

  function renderValue() {
    if (isFetching) return <Skeleton className="my-0.5 h-4 w-10" />;

    if (!value) return '-';

    return format(value);
  }

  return (
    <div
      className={clsx(
        'border-fx-neutral-200 flex flex-col gap-1 rounded-md border px-4 py-3',
        className,
      )}
    >
      <img src={icon} alt="" className="h-4 w-4" />
      <Typography variant="subtitle2">{label}</Typography>
      <Typography variant="body1">{renderValue()}</Typography>
    </div>
  );
}
